import { Controller } from '@hotwired/stimulus';
import flatpickr from 'flatpickr';
import { Lithuanian } from 'flatpickr/dist/l10n/lt.js';

export default class extends Controller {
    connect() {
        flatpickr(this.element, {
            locale: this.getLocale(),
            dateFormat: 'Y-m-d',
            disableMobile: true,
        });
    }

    getLocale() {
        switch (document.documentElement.lang.split('-')[0]) {
            case 'lt':
                return Lithuanian;
            case 'en':
                return english;
            case 'ru':
                return Russian;
            default:
                return Lithuanian;
        }
    }
}
